/**
 * A controller to control GoogleAnalytics requests
 */
define(function (require) {
    "use strict";
    var GoogleAnalytics = {
        _runGoogleAnalyticsTag: function (hash) {
            try {
                (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
                    (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
                    m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
                })(window,document,'script','//www.google-analytics.com/analytics.js','ga');

                ga('create', 'UA-277946-1', 'auto', {'allowLinker': true});
                ga('send', 'pageview', { 'page': window.location.pathname + (hash || window.location.hash) });
            } catch (exp) {
                this.logger.error("Error running the google analytics tag" + exp);
            }

        },

        _runGoogleAnalyticsEvent: function(catagory) {
            try {
                (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
                    (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
                    m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
                })(window,document,'script','//www.google-analytics.com/analytics.js','ga');

                ga('create', 'UA-277946-1', 'auto', {'allowLinker': true});
                ga('send', 'event', catagory, 'create-button-clicked', {'page': window.location.pathname + window.location.hash });
            } catch (exp) {
                this.logger.error("Error running the google analytics tag" + exp);
            }

        }
    }

    return GoogleAnalytics;
});
